import type { ReactNode } from "react";

import { RemoteErrorAlert } from "src/components/PageState/RemoteErrorAlert";

export type FormFieldLoadErrorProps = {
    message: ReactNode;
    retryLabel?: ReactNode;
    onRetry?: () => void | Promise<unknown>;
};

/** Shared explicit error state for form fields backed by remote option lists. */
export const FormFieldLoadError = ({ message, retryLabel, onRetry }: FormFieldLoadErrorProps) => (
    <RemoteErrorAlert
        message={message}
        onRetry={retryLabel === undefined ? undefined : onRetry}
        retryLabel={retryLabel}
        status="server-error"
    />
);
